const PAYMENT_LINK_PERIOD_PAYMENTS = {
  ONE_DAY: 'one_day',
  WEEK: 'week',
  TWO_WEEK: 'two_week',
  MONTH: 'month',
}

const PAYMENT_LINK_PERIODS_TYPE = {
  FIXED: 1,
  FREE: 2,
}

const PAYMENT_LINK_TYPES = {
  REUSABLE: false,
  ONE_TIME: true,
}

const PAYMENT_LINK_STATUS = {
  active: 'active',
  // paused: 'paused',
  disabled: 'disabled',
  expired: 'expired',
  paid: 'paid',
}

export {
  PAYMENT_LINK_PERIOD_PAYMENTS,
  PAYMENT_LINK_PERIODS_TYPE,
  PAYMENT_LINK_TYPES,
  PAYMENT_LINK_STATUS,
}
